<script>
	// svelte/d3 libs
	import { scaleLinear } from 'd3-scale';
	import { elasticOut, linear, quartIn } from 'svelte/easing';

	import {throttle} from '../actions/throttle.js';
    import State from '../stores/State.js'; 
	import { tweened } from 'svelte/motion';
	import { fade, scale } from 'svelte/transition';
	import { flip } from 'svelte/animate';
	import { onMount } from 'svelte';

	

	// data
	export let driverLastLaps;


	export let playing = false;

	let intro = false;
	let transx = false;
	let transy = false;


	const delay = 2000;
	let introDelay = 0;

	const tracesIn = tweened(undefined, {
		delay: delay,
		easing: quartIn
	});

	const dotIntro = tweened (undefined, {

	})




	$: tracesIn.set(playing ? 1 : 0);


	let winH;
	let width = 900;
	$: height = winH < 770 ? 400 : 450;

	const padding = { top: 35, right: 245, bottom: 70, left: 20 };
	const xTicks = [[30000, '30s'], [60000, '1m'], [90000,'1m30s']]

	$: xExtent = [90000, 0];	

	$: $State.f_x = scaleLinear()
		.domain(xExtent)
		.range([padding.left, width - padding.right]);

	$: $State.f_y = scaleLinear()
		.domain([1, 10])
		.range([padding.top, height - padding.bottom]);


	onMount(() => {
		// "if previous chart" logic to prevent transition if coming from different chart
		// will need to adjust the delay on the FT chart intro as well
		if ($State.prevChart === 'Lightning') {
			transx = false;
			transy = false;
			intro = true;
			introDelay = 2500; 

			const timeout0 = setTimeout(() => { transx=true ;}, 900);
			const timeout1 = setTimeout(() => { transy=true ;}, 1500);
			const timeout2 = setTimeout(() => { intro=false ;}, 2500);
			// $State.prevChart = 'Finish'
			return () => {clearTimeout(timeout0); clearTimeout(timeout1); clearTimeout(timeout2); intro=false; };
		}
		else {
			intro=false;
			introDelay = 0;
			// $State.prevChart = 'Finish'
		}
	});
</script>


<svelte:window bind:innerHeight={winH}/>

<container>

{#if intro}
<div class="chart chartTrans" id="finishChartIntro" clientWidth={width} clientHeight={height} transition:fade={{duration: 500}}>
	<svg style="position: absolute">
		{#each driverLastLaps as lp (lp.race + lp.driver)}
			<rect
				animate:flip={{duration:d => Math.sqrt(d) * 70}}
				class="{lp.pos === 1 ? 'topTraceDot' : 'traceDot'}"
				id="FTTrans-1" 
				x="{transx ? $State.f_x(lp.vsP1)-3 : $State.l_x(lp.vsP105)-2}"
				width="{lp.pos === 1 ? 5 : 4}" 
				y="{transy ? $State.f_y(lp.pos) + 7 : $State.l_y(lp.lap)-5}"
				height="{lp.pos === 1 ? 12 : 10}" 
				>
			</rect>
		{/each}
	</svg>
</div>
{/if}


<div class="chart" id="finishChart"
	bind:clientWidth={width} bind:clientHeight={height} in:fade={{delay: $State.prevChart === 'Lightning' ? 2500 : 0}}   out:fade={{duration: $State.noFade ? 0 : 500}}>
	<svg>
		<defs>
			<linearGradient id="grad-pinkFade" x1="0%" y1="0%" x2="100%" y2="0%">
				<stop stop-color="#F3C9BC" stop-opacity="0"/>
				<stop offset="1" stop-color="#F3C9BC"/>
			</linearGradient>
			<linearGradient id="grad-redFade" x1="0%" y1="0%" x2="100%" y2="0%">
				<stop stop-color="#FF3263" stop-opacity="0.1"/>
				<stop offset="1" stop-color="#FF3263" />
			</linearGradient>
			<linearGradient id="grad-blueFade" x1="0%" y1="0%" x2="100%" y2="0%">
				<stop stop-color="#B3CEED" stop-opacity="0"/>
				<stop offset="1" stop-color="#5C86B5"/>
			</linearGradient>
			<radialGradient id="grad-finish" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0 235.5) rotate(-90) scale(235.5 162450)">
				<stop offset="0.5" stop-color="white" stop-opacity="0.6"/>
				<stop offset="1" stop-color="white" stop-opacity="0"/>
			</radialGradient>
			
			<filter id="blur1"x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1" /></filter>
			<filter id="blur1-5"x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1.5" /></filter>
			<filter id="blur8"x="-300%" y="-150%" width="700%" height="400%"><feGaussianBlur stdDeviation="8" /></filter>
		</defs>


	
		
		<!-- chart elements -->		
		<g class="traces" opacity={playing ? $tracesIn : 1}>
			{#each driverLastLaps as lp (lp.race + lp.driver)}
				<!-- First Place gets different lines/dots -->
				{#if lp.pos == 1}
					<rect 
						class="topTraceBlur" 
						x="-100"
						width="{$State.f_x(lp.vsP1)+100}" 
						y="{$State.f_y(lp.pos) + 6}"
						height="14" >
					</rect>
					<rect
						class="topTraceLine" 
						x="-40"
						width="{$State.f_x(lp.vsP1)+40}" 
						y="{$State.f_y(lp.pos) + 10}"
						height="6" >
					</rect>
					<rect
						class="topTraceDotBlur" 
						x="{$State.f_x(lp.vsP1)-4}"
						width="10" 
						y="{$State.f_y(lp.pos) + 0}"
						height="26" >
					</rect>
					<rect
						class="topTraceDot"
						id="FTTrans-1" 
						x="{$State.f_x(lp.vsP1)-3}"
						width="5" 
						y="{$State.f_y(lp.pos) + 7}"
						height="12" >
					</rect>

				<!-- Driver was not lapped so can visualize -->
				{:else if lp.lap == $State.selRace.lapCount}
					<rect
						class="traceLine" 
						x="{$State.f_x(lp.vsP1)}"
						width="{$State.f_x(0)-$State.f_x(lp.vsP1)}" 
						y="{$State.f_y(lp.pos) +10}"
						height="6" >
					</rect>
					<rect
						class="traceDotBlur" 
						style="transform: translate3d({$State.f_x( playing ? 0 :lp.vsP1)-3}px, 0px, 0px); 
							transition-delay: {playing ? delay : 0}ms;
							transition-duration: {playing ? lp.vsP1 : 300}ms;
							transition-timing-function: linear;"
						width="6" 
						y="{$State.f_y(lp.pos) + 3}"
						height="20" >
					</rect>
						<!-- x="{$State.f_x(lp.vsP1)-3}" -->
					<rect
						class="traceDot" 
						id="FTTrans-{lp.pos}" 
						style="transform: translate3d({$State.f_x( playing ? 0 :lp.vsP1)-3}px, 0px, 0px); 
							transition-delay: {playing ? delay : 0}ms;
							transition-duration: {playing ? lp.vsP1 :300}ms;
							transition-timing-function: linear;"
						width="4" 
						y="{$State.f_y(lp.pos) + 8}"
						height="10" >
					</rect>
				<!-- Driver was lapped so just put in text to say so -->
				{:else }
					<text text-anchor="end"
						dominant-baseline="middle"
						x="{$State.f_x(0) - 10}"
						y="{$State.f_y(lp.pos) +14}"
						>
							+ {$State.selRace.lapCount - lp.lap} Lap{$State.selRace.lapCount - lp.lap > 1 ? 's' : ''} 
					</text>
					<!-- <rect	class="traceLineLapped" x="{$State.f_x(lp.vsP1)}" width="{$State.f_x(0)-$State.f_x(lp.vsP1)}" y="{lp.pos * 40 +10}"	height="6" ></rect> -->
				{/if}
				
				<!-- Driver Name Label -->
				<text dominant-baseline="hanging"
					class="driverLabel"
					x="{$State.f_x(0) + 20}"
					y="{$State.f_y(lp.pos) + 6}"
					class:topLabel="{lp.pos === 1}"
					>
						{lp.driver}
				</text>
				<!-- Driver time label -->
				<text dominant-baseline="hanging"
					text-anchor="end"
					class="timeLabel"
					x="{$State.f_x(0) + 180}"
					y="{$State.f_y(lp.pos) + 6}"
					class:hidden="{lp.pos === 1}"
					>
						+{(Math.round(lp.vsP1/100)/10).toFixed(1)}s
				</text>

				<!-- Trophy Icon instead of time for first place-->
				{#if lp.pos == 1 }
					<g transform="translate({$State.f_x(0) + 160},{$State.f_y(lp.pos) +3})">
						<path d="M11.8023 13.05L12.4273 12.75C14.1773 11.9 15.2273 9.9 15.2273 8.225V0.675C15.2273 0.3 14.8773 0 14.4773 0H4.52734C4.10234 0 3.77734 0.3 3.77734 0.675V8.225C3.77734 9.9 4.85234 11.9 6.57734 12.75L7.20234 13.05C7.70234 13.3 8.02734 13.775 8.02734 14.275V16.7H6.72734C6.47734 16.7 6.27734 16.9 6.27734 17.15V18.5H4.95234C4.52734 18.5 4.20234 18.85 4.20234 19.25V20.225C4.20234 20.35 4.30234 20.425 4.40234 20.425H14.5523C14.6773 20.425 14.7523 20.325 14.7523 20.225V19.25C14.7523 18.825 14.4023 18.5 14.0023 18.5H12.6773V17.15C12.6773 16.9 12.4773 16.7 12.2273 16.7H10.9273V14.275C10.9773 13.775 11.3023 13.3 11.8023 13.05ZM10.8773 9L9.50234 8.275L8.12734 9C8.00234 9.075 7.85234 9.05 7.75234 8.975C7.62734 8.9 7.57734 8.75 7.60234 8.625L7.85234 7.1L6.75234 6.025C6.65234 5.925 6.62734 5.775 6.65234 5.65C6.70234 5.525 6.80234 5.425 6.95234 5.4L8.47734 5.175L9.15234 3.8C9.20234 3.675 9.32734 3.6 9.47734 3.6C9.62734 3.6 9.75234 3.675 9.80234 3.8L10.4773 5.175L12.0023 5.4C12.1523 5.425 12.2523 5.525 12.3023 5.65C12.3523 5.775 12.3023 5.925 12.2023 6.025L11.1023 7.1L11.3523 8.625C11.3773 8.775 11.3273 8.9 11.2023 8.975C11.1273 9.025 11.0523 9.05 10.9773 9.05C10.9773 9.05 10.9273 9.025 10.8773 9Z" fill="#FF3263"/>
						<path d="M2.97583 1.7998H0.350832C0.175832 1.7998 0.000832524 1.94981 0.0258325 2.14981C0.0758325 3.34981 0.475832 7.27481 2.87583 9.02481C2.97583 9.0998 3.12583 9.02481 3.12583 8.89981V7.52481C3.12583 7.4748 3.10083 7.4498 3.07583 7.4248C2.60083 6.9248 2.20083 6.2498 1.90083 5.3748C1.67583 4.69981 1.50083 4.0248 1.42583 3.4498C1.40083 3.3248 1.50083 3.1998 1.62583 3.1998H2.97583C3.05083 3.1998 3.12583 3.1248 3.12583 3.0498V1.9748C3.12583 1.8748 3.05083 1.7998 2.97583 1.7998Z" fill="#FF3263"/>
						<path d="M15.925 7.4248C15.9 7.4498 15.875 7.4998 15.875 7.52481V8.89981C15.875 9.02481 16.025 9.0998 16.125 9.02481C18.525 7.27481 18.925 3.32481 18.975 2.14981C18.975 1.94981 18.825 1.7998 18.65 1.7998H16.025C15.95 1.7998 15.875 1.8748 15.875 1.9498V3.0498C15.875 3.1248 15.95 3.1998 16.025 3.1998H17.375C17.5 3.1998 17.6 3.3248 17.575 3.4498C17.475 4.0248 17.325 4.69981 17.1 5.3748C16.775 6.2498 16.4 6.9248 15.925 7.4248Z" fill="#FF3263"/>
					</g>
				{/if}



			{/each}


			

			<!-- x axis -->
			<g class="axis x-axis">
				{#each xTicks as tick}
					<g class="tick tick-{ tick[1] }">
						<line y1="{height-20}" y2="{height-15}" x1="{$State.f_x(tick[0])}" x2="{$State.f_x(tick[0])}"></line>
						<text y="{height-2}" x="{$State.f_x(tick[0])}">{tick[1]}</text>
					</g>
				{/each}
			</g>
			
		</g>
		<line class="finishLine" x1="{$State.f_x(0)}" x2="{$State.f_x(0)}" y1="0%" y2="100%"/>


	</svg>
</div>


</container>

		
	
<style>
	container {
		display: block;
		position: absolute;
		width: 100%
	}


	.finishLine {
		stroke: url(#grad-finish);
		/* opacity:0.6; */
		stroke-dasharray: 10;
		stroke-width: 2;
	}

	.timeLabel, .driverLabel {
		fill: #9CBCE0;
		font-size: 14px;
	}

	.hidden {
		visibility: hidden;
	}

	.topLabel {
		fill: #FF3263;
	}

	.topTraceLine {
		fill: url(#grad-pinkFade)
	}
	.topTraceBlur {
		fill: url(#grad-redFade);
		/* filter: blur(8px);
		-webkit-filter: blur(8px); */
		filter: url(#blur8);
	}

	.topTraceDot {
		fill: #ECFAF9;
		filter: blur(1.5px);
		-webkit-filter: blur(1.5px);
		/* filter: url(#blur1-5); */
	}

	.topTraceDotBlur {
		fill: #FF3263;
		/* filter: blur(8px);
		-webkit-filter: blur(8px); */
		filter: url(#blur8);
	}


	.traceDot {
		fill: #ECFAF9;
		filter: blur(1px);
		-webkit-filter: blur(1px);
		/* filter: url(#blur1); */
	}

	.traceDotBlur {
		fill: #6A8CB2;
		/* filter: blur(8px);
		-webkit-filter: blur(8px); */
		filter: url(#blur8);
	}

	.traceLine {
		fill: url(#grad-blueFade);
	}

	/* .traceLineLapped {
		fill: url(#grad-blueFade);
		filter: blur(1px);
		-webkit-filter: blur(1px);
		filter: url(#blur1);
	} */

	.chart {
		width: 100%;
		max-width: 900px;
		max-height: 450px;
	}	
	
	.chartTrans {
		display: block;
		position: absolute;
		width: 100%;
		max-width: 900px;
		max-height: 500px;
	}

	svg {
		position: relative;
		width: 100%;
		height: 500px; 
		overflow: visible;
	}


	@media screen and (max-height: 770px) {
		svg {
			height: 400px; 
		}
		.chart {
			max-height: 400px;
		}
	}
	

</style>